import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Dashboard() {
  const [kpi, setKpi] = useState(null);
  const [digest, setDigest] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const [k, d] = await Promise.all([api.get("/kpi/home"), api.get("/digest/weekly")]);
        setKpi(k.data); setDigest(d.data);
      } catch {}
    })();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight mb-1">Home</h1>
      <p className="text-sm text-[#A1A1AA] mb-6">Operating KPIs across hiring, onboarding and people ops.</p>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-8">
        <K label="Time to hire" value={kpi ? `${kpi.time_to_hire_days}d` : "…"} />
        <K label="Time to ready" value={kpi ? `${kpi.time_to_ready_days}d` : "…"} />
        <K label="Form conversion" value={kpi ? `${kpi.form_conversion_pct}%` : "…"} />
        <K label="First-attempt pass" value={kpi ? `${kpi.first_attempt_pass_pct}%` : "…"} />
        <K label="90-day retention" value={kpi ? `${kpi.retention_90d_pct}%` : "…"} accent="pass" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="tt-card p-5">
          <div className="tt-label mb-3">This week</div>
          {!digest && <div className="text-sm text-[#71717A]">Loading…</div>}
          {digest && (
            <div className="text-sm space-y-2">
              <Row k="Leaves this week" v={digest.leaves.this_week} />
              <Row k="Pending leave requests" v={digest.leaves.pending} />
              <Row k="Overdue tickets" v={digest.overdue_tickets} accent={digest.overdue_tickets > 0 ? "warn" : "neutral"} />
              <Row k="New applicants" v={digest.hiring.new_applicants} />
              <Row k="Interviews booked" v={digest.hiring.interviews_booked} />
              <Row k="Stuck in training" v={digest.training.stuck} />
              <Row k="Praise this week" v={digest.praise_vs_issues.praise} accent="pass" />
              <Row k="Issues this week" v={digest.praise_vs_issues.issues} accent="warn" />
            </div>
          )}
        </div>
        <div className="tt-card p-5">
          <div className="tt-label mb-3">Upcoming</div>
          {!digest && <div className="text-sm text-[#71717A]">Loading…</div>}
          {digest && (
            <>
              <div className="text-xs text-[#71717A] font-mono mb-1">Probation ending</div>
              {digest.upcoming.probation_ends.length === 0 && <div className="text-sm text-[#A1A1AA]">—</div>}
              {digest.upcoming.probation_ends.map((e) => (
                <div key={e.employee_id} className="text-sm">{e.display_name || e.legal_name} <span className="font-mono text-xs text-[#71717A]">· {e.probation_end}</span></div>
              ))}
              <div className="text-xs text-[#71717A] font-mono mt-3 mb-1">Anniversaries</div>
              {digest.upcoming.anniversaries.length === 0 && <div className="text-sm text-[#A1A1AA]">—</div>}
              {digest.upcoming.anniversaries.map((a) => (
                <div key={a.employee_id} className="text-sm">{a.name} <span className="font-mono text-xs text-[#71717A]">· {a.date}</span></div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function K({ label, value, accent }) {
  const color = accent === "warn" ? "text-[#F5A524]" : accent === "pass" ? "text-[#22C55E]" : "text-[#F4F4F5]";
  return (
    <div className="tt-card p-4">
      <div className="tt-label mb-2">{label}</div>
      <div className={`font-mono text-2xl font-semibold ${color}`} data-testid={`kpi-${label.toLowerCase().replace(/\s+/g,'-')}`}>{value}</div>
    </div>
  );
}

function Row({ k, v, accent }) {
  const color = accent === "warn" ? "text-[#F5A524]" : accent === "pass" ? "text-[#22C55E]" : "text-[#F4F4F5]";
  return (
    <div className="flex items-center justify-between py-1 border-b border-[#1E1E1E] last:border-0">
      <span className="text-[#A1A1AA]">{k}</span>
      <span className={`font-mono ${color}`}>{v}</span>
    </div>
  );
}
